"use client";

import CustomImage from '@/components/image';
import styles from './_physiologic.module.scss';
// import TwoColTable from '@/components/table';

export default function HcpClinicalInformationPhysiologic() {
  return (
    <section className={styles.physiologic}>
      <div className={`container ${styles.physiologic_container}`}>
        <h2 className={styles.physiologic_heading}>More physiologic GC regimens achieved by week 24 by some adults taking CRENESSITY<sup>8</sup></h2>
        <div className={styles.physiologic_data}>
          <div className={styles.physiologic_data_item}>
            <div className={styles.physiologic_data_heading}>
              Adults taking <span className="text-hcp-eggplant">dexamethasone</span><br />
              who switched to dexamethasone-free regimens<sup>8</sup>
            </div>
            <CustomImage
              src='/images/page/hcp/clinical-information/Clinical-Information_Adult-Dexamethasone-Free-Regimens.svg'
              width={566}
              height={441}
              alt='88% of patients taking CRENESSITY switched to dexamethasone-free regimens vs 40% with placebo.'/>
          </div>
          <div className={styles.physiologic_data_item}>
            <div className={styles.physiologic_data_heading}>
              Adults taking <span className="text-hcp-eggplant">prednisone</span> <br />
              who switched to hydrocortisone-only regimens<sup>8</sup>
            </div>
            <CustomImage
              src='/images/page/hcp/clinical-information/Clinical-Information_Adult-Prednisone-Hydrocortisone-Only-Regimens.svg'
              width={566}
              height={441}
              alt='32% of patients taking CRENESSITY switched to hydrocortisone-only regimens vs 11% with placebo.'/>
          </div>
          <div className={styles.physiologic_data_item}>
            <div className={styles.physiologic_data_heading}>
              Adults taking <span className="text-hcp-eggplant">hydrocortisone</span> only <br />
              who achieved reductions in number of daily doses<sup>8</sup>
            </div>
            <CustomImage
              src='/images/page/hcp/clinical-information/Clinical-Information_Adult-Hydrocortisone-Only-Regimens.svg'
              width={566}
              height={441}
              alt='37% taking CRENESSITY with a hydrocortisone-only regimen saw reductions in number of daily doses vs 12% with placebo.'/>
          </div>
          <div className={styles.physiologic_data_aside}>
            <p className={`hcp-callout ${styles.physiologic_data_aside_callout}`}>The most nonphysiologic glucocorticoid type (eg, prednisone, prednisolone, methylprednisolone, or dexamethasone) and timing (ie, bedtime GC dose) were reduced or eliminated first.<sup>10</sup></p>
          </div>
        </div>
        <p className={styles.purpleText}>
          These prespecified exploratory endpoints were not adjusted for multiplicity; these descriptive results could represent chance findings.<sup>8</sup>
        </p>
      </div>
    </section>
  );
}
